import type { Task } from './types';

/**
 * Was der Bewertungsbogen zeigt und erlaubt — fünf Schalter aus dem alten OSCE-Client, die der
 * Nutzer am 2026-10-02 auch in Stage wollte (Relay-Namen in Klammern).
 *
 * Vorgabe ist überall `true`: so sah der Bogen bisher aus.
 */
export interface BogenAnzeige {
  /** Punktfeld färbt sich nach Stand (`colorful_text`). */
  farbig: boolean;
  /** Punkte an der Aufgabe sichtbar (`show_task_points`). */
  aufgabenpunkte: boolean;
  /** Gesamtpunkte sichtbar (`show_sum_points`). */
  summe: boolean;
  /** Punktwert von Hand setzbar (`editable_task_points`). */
  aenderbar: boolean;
  /** Schauspieler wählbar und sichtbar (`actors_enabled`). */
  schauspieler: boolean;
}

export type BogenAnzeigeSchalter = keyof BogenAnzeige;

export const VOLLE_ANZEIGE: BogenAnzeige = {
  farbig: true,
  aufgabenpunkte: true,
  summe: true,
  aenderbar: true,
  schauspieler: true,
};

/**
 * ⚠️ **Globale Bewertung ist ausgenommen** (Entscheidung des Nutzers, 2026-10-02): dort gibt es
 * keinen anderen Weg zu Punkten als das Punktfeld. Ausgeblendet oder gesperrt wäre die Aufgabe
 * gar nicht mehr zu bewerten.
 */
const istGlobal = (task: Task) => task.scoring.kind === 'global';

/** Steht das Punktfeld an dieser Aufgabe? */
export const punktfeldSichtbar = (task: Task, a: BogenAnzeige) =>
  a.aufgabenpunkte || istGlobal(task);

/** Öffnet ein Tipp aufs Punktfeld die Punkteingabe? Häkchen und Auswahl wirken unabhängig davon. */
export const punktfeldBedienbar = (task: Task, a: BogenAnzeige) => a.aenderbar || istGlobal(task);

/** Stehen Punkte an Checklistenzeilen und Auswahlen? */
export const teilpunkteSichtbar = (a: BogenAnzeige) => a.aufgabenpunkte;
